import { devLog } from '@/lib/logging';
import {
  InteractionRequiredAuthError,
  PublicClientApplication,
} from '@azure/msal-browser';
import { configuration } from './config';

devLog(configuration);

export const application = new PublicClientApplication(configuration);

export async function getAuthToken(scopes: string[]): Promise<string | null> {
  const accounts = application.getAllAccounts();
  if (!accounts || accounts.length === 0) {
    return null;
  }

  const account = accounts[0];

  const request = {
    scopes: scopes,
    account: account,
  };

  try {
    const response = await application.acquireTokenSilent(request);

    return response.accessToken;
  } catch (error) {
    if (!(error instanceof InteractionRequiredAuthError)) {
      devLog(error);
      throw error;
    }
    const response = await application.acquireTokenPopup(request);

    return response.accessToken;
  }
}
